// Placeholder list shown beneath template-bearing inputs so admins don't have
// to remember which tokens are supported. Case-sensitive; unknown placeholders
// are left literal in the rendered output. Spec §1.5.
const PLACEHOLDERS = '{accountName} {suburb} {shortSuburb} {suburbSlug} {slug} {state} {gymInfo}';

export function PlaceholderHint() {
  return (
    <p className="text-xs text-slate-500 mt-1">
      Supports placeholders: <code className="font-mono">{PLACEHOLDERS}</code>.
      Unknown placeholders are left literal. Length caps apply to the authored
      string (including tokens), not the rendered output.
    </p>
  );
}
